import { ITriviaQuestion } from "config/types";
import { logout } from "store/actions/authentication";
import { fetchTrivia } from "store/actions/trivia";

import { createReducer } from "@reduxjs/toolkit";

interface ITriviaState {
  questions: {
    [key: string]: ITriviaQuestion;
  };
  slugs: string[];
}

const defaultState = {
  questions: {} as { [key: string]: ITriviaQuestion },
  slugs: [] as string[],
} satisfies ITriviaState;

const trivia = createReducer(defaultState, builder => {
  builder
    .addCase(fetchTrivia.fulfilled, (state, action) => {
      const { slugs, questions } = action.payload.reduce(
        (memo: ITriviaState, question: ITriviaQuestion) => {
          memo.questions[question.slug] = question;
          memo.slugs.push(question.slug);

          return memo;
        },
        { questions: {}, slugs: [] }
      );

      state.slugs = slugs;
      state.questions = questions;
    })
    .addCase(logout, () => defaultState);
});

export default trivia;
